// ComingSoonPage — the eager placeholder every domain + admin route renders
// until its real feature page lands. Stays eager (tiny — nothing to defer);
// the `m-<area>` lazy boundaries (vite.config.ts) are the documented seam for
// when a heavy real page replaces a stub.
//
// Renders content only — the surrounding <main> landmark belongs to the frame
// (ProjectLayout / AdminLayout). `labelKey` (a `nav` namespace key) names the
// area so each stub reads as "Sites — Coming soon", not a generic blank.

import { useTranslation } from 'react-i18next';
import { icons } from '../components/ui/icons.js';
import { useDocumentTitle } from '../hooks/useDocumentTitle.js';

export interface ComingSoonPageProps {
  /** `nav` namespace key for the area name (e.g. 'domains.sites'). */
  labelKey?: string;
}

export function ComingSoonPage({ labelKey }: ComingSoonPageProps) {
  const { t } = useTranslation('nav');
  // Tab-title leaf = the area name (e.g. "Sites" → "Sites · Acme Solar").
  useDocumentTitle(labelKey ? t(labelKey) : undefined);
  return (
    <div className="flex flex-col items-center justify-center text-center gap-3 py-16 px-4">
      <icons.clock aria-hidden size={40} className="text-[var(--color-text-disabled)]" />
      <h1 className="text-xl font-semibold text-[var(--color-text-primary)]">
        {labelKey ? t(labelKey) : t('comingSoon.title')}
      </h1>
      <p className="max-w-md text-sm text-[var(--color-text-secondary)]">{t('comingSoon.body')}</p>
    </div>
  );
}

export default ComingSoonPage;
